/* eslint-disable import/prefer-default-export */
export var ERROR_STATUSES = ['return_to_sender', 'failure', 'error'];